

<div id="sidebar" class="main-div ">
  <div class="titlebar-div " id="titleBar">
    <span (click)="onCloseClick($event)" class="cvt-icon-closeDelete grid-cmd-icons close-img" title="Close"></span>
    <span>Result Summary Graph(s)</span><br>
    <span class="span-subtitle">{{subTitle}} ({{universalAuditID}})</span>
  </div>
  <div class="legend-div" id="legendDiv">
    <table>
      <tr *ngIf="component=='RA'">
        <td *ngFor="let row of legend">
          <div [style.backgroundColor]="row.bgcolor" class="legend-div-img"></div>
          <span>{{row.name}}</span>
        </td>
      </tr>
      <tr *ngIf="component=='RV' || component=='RVRS'">
        <td *ngFor="let row of legend let i = index">
          <div *ngIf="i<=2" [style.backgroundColor]="row.bgcolor" class="legend-div-img"></div>
          <span *ngIf="i<=2">{{row.name}}</span>
        </td>
      </tr>
    </table>
    <table *ngIf="component=='RV' || component=='RVRS'">
      <tr>
        <ng-container *ngFor="let row of legend let i = index">
          <td *ngIf="i>2">
            <div  [style.backgroundColor]="row.bgcolor" class="legend-div-img"></div>
            {{row.name}}
          </td>
        </ng-container>
      </tr>
    </table>
  </div>
  <div class="charting-div" id="chartingDiv">
    <ng-container *ngIf="component=='RA' || component=='RV'">
      <kendo-chart  [seriesColors]="seriesColor" *ngIf="isAmadeusData">
        <kendo-chart-area >
          <kendo-chart-title text="Amadeus"></kendo-chart-title>
          <kendo-chart-tooltip format="{0}"></kendo-chart-tooltip>
          <kendo-chart-legend class="chart" [visible]="false"></kendo-chart-legend>
          <kendo-chart-series class="chart">
            <kendo-chart-series-item class="chart" type="pie"
              [data]="AmadeusChartData"
              field="value"
              categoryField="category">
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart-area>
      </kendo-chart>
      <div class="break" *ngIf="isAmadeusData"></div>
      <kendo-chart  [seriesColors]="seriesColor"  *ngIf="isApolloData">
        <kendo-chart-area >
          <kendo-chart-title text="Apollo"></kendo-chart-title>
          <kendo-chart-tooltip format="{0}"></kendo-chart-tooltip>
          <kendo-chart-legend class="chart" [visible]="false"></kendo-chart-legend>
            <kendo-chart-series class="chart">
              <kendo-chart-series-item class="chart" type="pie"
                [data]="ApolloChartData"
                field="value"
                categoryField="category">
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart-area>
      </kendo-chart>
      <div class="break" *ngIf="isApolloData"></div>
      <kendo-chart  [seriesColors]="seriesColor" *ngIf="isGalileoData">
        <kendo-chart-area >
          <kendo-chart-title text="Galileo"></kendo-chart-title>
          <kendo-chart-tooltip format="{0}"></kendo-chart-tooltip>
          <kendo-chart-legend class="chart" [visible]="false"></kendo-chart-legend>
          <kendo-chart-series class="chart">
            <kendo-chart-series-item class="chart" type="pie"
              [data]="GalileoChartData"
              field="value"
              categoryField="category">
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart-area>
      </kendo-chart>
      <div class="break" *ngIf="isGalileoData"></div>
      <kendo-chart  [seriesColors]="seriesColor"  *ngIf="isSabreData">
        <kendo-chart-area >
          <kendo-chart-title text="Sabre"></kendo-chart-title>
          <kendo-chart-tooltip format="{0}"></kendo-chart-tooltip>
          <kendo-chart-legend class="chart" [visible]="false"></kendo-chart-legend>
          <kendo-chart-series class="chart">
            <kendo-chart-series-item class="chart" type="pie"
              [data]="SabreChartData"
              field="value"
              categoryField="category">
          </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart-area>
      </kendo-chart>
      <div class="break"  *ngIf="isSabreData"></div>
      <kendo-chart  [seriesColors]="seriesColor"  *ngIf="isWorldspanData">
        <kendo-chart-area >
          <kendo-chart-title text="Worldspan"></kendo-chart-title>
          <kendo-chart-tooltip format="{0}"></kendo-chart-tooltip>
          <kendo-chart-legend class="chart" [visible]="false"></kendo-chart-legend>
          <kendo-chart-series class="chart">
            <kendo-chart-series-item class="chart" type="pie"
              [data]="WorldspanChartData"
              field="value"
              categoryField="category">
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart-area>
      </kendo-chart>
      <div class="break" *ngIf="isWorldspanData"></div>
    </ng-container>
    <ng-container *ngIf="component=='RVRS'">
      <kendo-chart [seriesColors]="seriesColor">
        <kendo-chart-area >
          <kendo-chart-title text="Hotels Not In Program"></kendo-chart-title>
          <kendo-chart-tooltip format="{0}"></kendo-chart-tooltip>
          <kendo-chart-legend class="chart" [visible]="false"></kendo-chart-legend>
          <kendo-chart-series class="chart">
            <kendo-chart-series-item class="chart" type="pie"
              [data]="HotelsNotInProgramChartData"
              field="value"
              categoryField="category">
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart-area>
      </kendo-chart>
      <div class="noDataSeries" *ngIf="ChartData && !ChartData['AmadeusOutOfProgram'] && !ChartData['ApolloOutOfProgram'] && !ChartData['GalileoOutOfProgram'] && !ChartData['SabreOutOfProgram'] && !ChartData['WorldspanOutOfProgram']">
        No Data Series.
      </div>
    </ng-container>
  </div>
</div>
